import { call, put, takeEvery } from "redux-saga/effects"
import { callApi } from "sagas/Api"
import {
  PUT_LOCALE_AGREEMENT,
  setSuccess,
  storeLocaleAgreement,
  storeLocationModalIsOpen,
} from "actions"
import { putLocaleAgreement } from "apis/LocaleAgreement"
import { handlingPutApiError } from "./CommonErrorHandling"

export function* handlePutLocaleAgreements() {
  yield takeEvery(PUT_LOCALE_AGREEMENT, execPutLocaleAgreements)
}

export function* execPutLocaleAgreements(action) {
  yield put(storeLocationModalIsOpen(false))
  const { payload, error } = yield call(
    callApi,
    putLocaleAgreement,
    action.payload
  )

  if (payload && !error) {
    yield put(storeLocaleAgreement(action.payload))
    yield put(setSuccess(payload))
  } else {
    yield call(handlingPutApiError, error)
  }
}
